var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notes)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.notes)}}):_c('div',[_c('em',{staticClass:"text-muted",domProps:{"textContent":_vm._s(_vm.$t('common.not-available'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }